import angular from 'angular';
import SoundFactory from './sound.factory';

let soundModule = angular.module('app.sound', [])

.factory('Sound', SoundFactory)

.name;

export default soundModule;


// WEBPACK FOOTER //
// ./client/app/common/sound/index.js